import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from 'store/index';
import * as smoothscroll from 'smoothscroll-polyfill';
import App from './App';
import initI18nClientSide from './i18nClient';
import './styles/global.scss';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const renderMethod = module.hot ? render : hydrate;

initI18nClientSide().then(() => {
  renderMethod(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,
    document.getElementById('optimalprintFrontend'),
  );
});

if (module.hot) {
  module.hot.accept();
}
